export enum rightPanelDisplayState {
  hidden,
  displaying,
}
